import { AuthError } from "@supabase/supabase-js";
import { strings } from "./strings";

/**
 * Translate a thrown error into a user-friendly string. Keeps copy consistent
 * with the rest of the app while never leaking raw upstream messages.
 */
export function describeAuthError(error: unknown): string {
  if (error == null) return strings.common.unexpectedError;

  if (error instanceof AuthError) {
    switch (error.status) {
      case 400:
      case 422:
        return strings.common.invalidOtp;
      case 401:
      case 403:
        return strings.delete.reverificationBody;
      case 429:
        return "Too many attempts. Please wait a moment before trying again.";
      case 500:
      case 502:
      case 503:
      case 504:
        return strings.common.networkError;
    }
    return error.message || strings.common.unexpectedError;
  }
  if (error instanceof Error) {
    return error.message || strings.common.unexpectedError;
  }
  return strings.common.unexpectedError;
}

/** Quick sanity check against the simplest invalid email shapes. */
export function isValidEmail(email: string): boolean {
  if (!email) return false;
  const trimmed = email.trim();
  if (trimmed.length < 5) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
}
